import React, { Component } from "react";

class Header extends Component {
  state = { activeSection: "home", showBackToTop: false };

  handleScroll = () => {
    const scrollPosition = window.scrollY;
    const sectionIds = ["about", "resume", "education", "contact"];
    const activeSection = scrollPosition < 120
      ? "home"
      : sectionIds.reduce((currentSection, sectionId) => {
        const section = document.getElementById(sectionId);
        return section && section.offsetTop <= scrollPosition + 100 ? sectionId : currentSection;
      }, "home");

    this.setState((previousState) => ({
      activeSection: previousState.activeSection === activeSection
        ? previousState.activeSection
        : activeSection,
      showBackToTop: scrollPosition > 240,
    }));
  };

  handleBackToTop = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  renderNavLink = (href, label, sectionId) => (
    <a
      className={this.state.activeSection === sectionId ? "active" : ""}
      href={href}
      aria-current={this.state.activeSection === sectionId ? "page" : undefined}
    >
      {label}
    </a>
  );

  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;

    return (
      <header id="home" className="site-header">
        <nav className="site-nav" aria-label="Primary">
          <a className="brand" href="#home"><span>MB  </span>{name}</a>
          <div className="nav-links">
            {this.renderNavLink("#about", "About", "about")}
            {this.renderNavLink("#resume", "Experience", "resume")}
            {this.renderNavLink("#education", "Education", "education")}
            {this.renderNavLink("#contact", "Contact", "contact")}
          </div>
          <a className="resume-link" href="#contact">Email Me</a>
        </nav>
        {this.state.showBackToTop && (
          <a className="back-to-top" href="#home" onClick={this.handleBackToTop} aria-label="Back to top" title="Back to top">
            <i className="fa-solid fa-arrow-up" aria-hidden="true"></i>
          </a>
        )}
      </header>
    );
  }
}

export default Header;
